<template>
    <div>
        <my-form class="form-page" v-model="form" table label-width="180px" @cancle="cancleHandler" :submit-url="`${getGetters('ageUrl')}/DingBiao/ZbHxrGs/add.json`">
            <el-form-item label="招标项目" class="table-full-row">
                {{ model.zbprocode }}--{{ model.zbproname }}
            </el-form-item>

            <el-form-item label="标段名称" prop="bdname" :rules="newRule('标段名称', 'required')">
                <my-select
                    :disabled="edit"
                    v-model="form.bdcode"
                    :data="bdList"
                    :props="{value:'id',label:'name'}"
                    2way="name"
                    :name.sync="form.bdname"
                    @select="bdChange" style="width:100%">
                </my-select>
            </el-form-item>
            <el-form-item label="标段编码" prop="bdcode" :rules="newRule('标段编码', 'required','sensitiveWords')">
                <el-input v-model="form.bdcode"></el-input>
            </el-form-item>
            <el-form-item label="公示名称" prop="gsname" :rules="newRule('公示名称', 'required','sensitiveWords')">
                <el-input v-model="form.gsname"></el-input>
            </el-form-item>
            <el-form-item label="公示类型" prop="gstypecode" :rules="newRule('公示名称', 'required')">
                <el-select v-model="form.gstypecode" placeholder="请选择公示类型" @change="getgstype">
                    <el-option v-for="(item,index) in gstypeList" :key="index" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="招标代理项目经理" prop="e_xmjl" :rules="newRule('招标代理项目经理', 'required','sensitiveWords')">
                <el-input v-model="form.e_xmjl"></el-input>
            </el-form-item>
            <el-form-item label="招标代理项目经理身份证号" prop="e_sfzh" :rules="newRule('招标代理项目经理身份证号', 'required','sensitiveWords')">
                <el-input v-model="form.e_sfzh"></el-input>
            </el-form-item>
            <el-form-item label="招标代理项目经理资质" prop="e_jlzz" :rules="newRule('招标代理项目经理资质', 'required','sensitiveWords')">
                <el-input v-model="form.e_jlzz"></el-input>
            </el-form-item>
            <el-form-item label="开标时间" prop="e_kbsj" :rules="newRule('开标时间', 'required')">
                <el-date-picker
                    v-model="form.e_kbsj"
                    type="datetime"
                    value-format="yyyy-MM-dd HH:mm"
                    format="yyyy-MM-dd HH:mm"
                >
                </el-date-picker>
            </el-form-item>
            <el-form-item label="公示开始时间" prop="gsstarttime" :rules="newRule('公示开始时间', 'required')">
                <el-date-picker
                    v-model="form.gsstarttime"
                    type="datetime"
                    value-format="yyyy-MM-dd HH:mm"
                    format="yyyy-MM-dd HH:mm"
                    :picker-options="datePickerOptions"
                    default-time="00:00:00"
                >
                </el-date-picker>
            </el-form-item>
            <el-form-item label="公示结束时间" prop="gsendtime" :rules="newRule('公示结束时间', 'required')">
                <el-date-picker
                    v-model="form.gsendtime"
                    :disabled="!form.gsstarttime"
                    type="datetime"
                    value-format="yyyy-MM-dd HH:mm"
                    format="yyyy-MM-dd HH:mm"
                    :picker-options="pickerOptionsend"
                    default-time="00:00:00"
                >
                </el-date-picker>
            </el-form-item>
            <el-form-item label="全部投标单位" prop="qbtbdw" :rules="newRule('全部投标单位', 'required','sensitiveWords')">
                <my-tag type="danger" style="margin-bottom:10px;" v-if="dwname">
                    <div class="reason">
                        【{{ dwname }}】 以上单位开标时被标记为无效投标单位，请自主选择是否将其加入全部投标单位字段。
                    </div>
                </my-tag>
                <el-input v-model="form.qbtbdw" type="textarea" :autosize="{ minRows: 4, maxRows: 10}"></el-input>
            </el-form-item>
            <el-form-item label="否决单位及理由" prop="fjdwjly" :rules="newRule('否决单位及理由', 'required','sensitiveWords')">
                <el-input v-model="form.fjdwjly" type="textarea" :autosize="{ minRows: 4, maxRows: 10}"></el-input>
            </el-form-item>
            <el-form-item label="招标限价（万元）" prop="zbxj" :rules="newRule('招标限价（万元）', 'required','sensitiveWords')" v-if="model.jt">
                <el-input v-model="form.zbxj"></el-input>
            </el-form-item>
            <el-form-item label="异议渠道或方式" prop="ext_complaints" :rules="newRule('异议渠道或方式', 'required','sensitiveWords')" class="table-full-row">
                <el-input v-model="form.ext_complaints" type="textarea" :autosize="{ minRows: 4, maxRows: 10}"></el-input>
                <my-tag type="danger" style="margin-bottom:10px;">
                    <div class="reason">
                        注：（对评标结果有异议的，应当在中标候选人公示期间向招标人或招标代理机构提出。）注明受理单位、联系人、电话、传真、邮箱等。
                    </div>
                </my-tag>
            </el-form-item>
            <el-form-item label="公示内容文本" prop="gscontent" :rules="newRule('公示内容文本', 'required')" class="table-full-row">
                <el-button v-if="form.bdcode&&((deptcode==='4'&&regioncode==='130200')||regioncode==='130300')" type="success" @click="pwfxdf()">各评委分项打分</el-button>
                <el-button v-if="form.bdcode" type="success" @click="neiRong()">自动生成公示（每次点击会重新生成并覆盖内容，请仔细核对内容，确认是否完整正确，可修改）</el-button>
                <ueditor v-model="form.gscontent"/>
            </el-form-item>
            <el-form-item label="附件" class="table-full-row">
                <my-tag type="danger">文件类型：jpg、pdf；单个文件大小1.5mb；</my-tag>
                <my-tag type="danger" style="margin-bottom:10px;" v-if="form.gstypecode==='2'">
                    <div class="reason">
                        特别提示：1、请按照“更正公告的格式”认真填写，加盖单位公章，并扫描上传。更正公告一经发布不能修改，请仔细检查。<a href="http://123.182.227.105:9999/tool/招标、中标更正.rar">（点此下载“更正公告格式”）</a>
                    </div>
                    <div class="reason" style="text-indent:5em">
                        2、请严格按照相关招投标法律、法规要求进行更正。
                    </div>
                </my-tag>
                <my-upload
                    :file-guid="form.fileguid|| ''"
                    file-type=".jpg,.pdf"
                    :file-size="1.5">
                </my-upload>
            </el-form-item>

            <template slot="btn" slot-scope="scope">
                <el-button @click="saveHandler(1, scope.submitHandler)" type="primary" icon="el-icon-circle-check">
                    提交
                </el-button>
                <el-button @click="saveHandler(0, scope.submitHandler)" type="warning" icon="el-icon-remove-outline">
                    暂存
                </el-button>
                <el-button icon="el-icon-circle-close" @click="scope.cancleHandler">取消</el-button>
            </template>
        </my-form>
        <el-drawer
            title="各评委分项打分"
            :visible.sync="table"
            direction="rtl"
            size="46.5%"
            :before-close="handleClose">
            <template>
                <template>
                    <el-button style="margin-bottom: 8px; margin-left: 5px;" size="mini" type="primary" round @click="copyData()" :loading="loading"><i class="el-icon-copy-document el-icon--left">
                        复制</i>
                    </el-button>
                    <div style="margin-left: 5px;">
                        <my-tag type="danger"><i class="el-icon-info el-icon--left"></i>请仔细核对评分结果，如发现有误请复制后手动修改</my-tag>
                    </div>
                </template>
                <div id="copyTable" v-if="tableDataAllList">
                    <template v-for="(x, y) in tableDataAllList">
                        <el-table :key="y" border stripe :data="x.nodeType === 'Range' ? x.listPfResult : x.nodeType === 'Offer' ? x.offerlist : x.nodeType === 'CreditScore' ? x.creditscoreList : []"
                                  :loading="loading">
                            <el-table-column :label="y + 1 + '、' + x.nodeName">
                                <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
                                <el-table-column property="tbdwname" label="单位名称"></el-table-column>
                                <el-table-column :key="index" width="100" v-for="(item,index) in pwhCyList" :label="index + 1 + '号评委'"
                                                 :prop="x.nodeType === 'Range' ? item.zjcode : x.nodeType === 'Offer' ? 'weightscore' : x.nodeType === 'CreditScore' ? 'score' : ''"></el-table-column>
                                <el-table-column :prop="x.nodeType === 'Range' ? 'sumScore' : x.nodeType === 'Offer' ? 'weightscore' : x.nodeType === 'CreditScore' ? 'score' : ''"
                                                 :label="[x.nodeType === 'Range' ? '汇总' : x.nodeType === 'Offer' ? '报价得分' : x.nodeType === 'CreditScore' ? '信用评价得分' : '']"
                                                 width="120"></el-table-column>
                            </el-table-column>
                        </el-table>
                    </template>
                    <!--                    <template v-if="offerSetList">
                                            <el-table border stripe :data="offerSetList" :loading="loading">
                                                <el-table-column :label="'2、' + bjdf">
                                                    <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
                                                    <el-table-column property="tbdwname" label="单位名称"></el-table-column>
                                                    <el-table-column width="100" v-for="(item,index) in pwhCyList" :label="index+1+'号评委'" property="weightscore">
                                                    </el-table-column>
                                                    <el-table-column property="weightscore" label="报价得分" width="120"></el-table-column>
                                                </el-table-column>
                                            </el-table>
                                        </template>
                                        <template v-if="creditScoreSetList">
                                            <el-table border stripe :data="creditScoreSetList" :loading="loading">
                                                <el-table-column :label="'3、' + xypjdf">
                                                    <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
                                                    <el-table-column property="tbdwname" label="单位名称"></el-table-column>
                                                    <el-table-column width="100" v-for="(item,index) in pwhCyList" :label="index+1+'号评委'" property="score">
                                                    </el-table-column>
                                                    <el-table-column property="score" label="信用评价得分" width="120"></el-table-column>
                                                </el-table-column>
                                            </el-table>
                                        </template>-->
                </div>
            </template>
        </el-drawer>
    </div>
</template>

<script>
import FORM_PAGE_MIXIN from '@views/mixins/form-page'

export default {
    mixins: [FORM_PAGE_MIXIN],
    data() {
        var that = this;
        return {
            form: {
                qbtbdw: '',
            },
            model: {},
            bdList: [],
            dwname: '',
            gstypeList: [
                {value: '1', label: '正常'},
                {value: '9', label: '其他'},
            ],
            // 开始时间
            datePickerOptions: {
                disabledDate(time) {
                    var today = new Date().pattern('yyyy/MM/dd');
                    return time.getTime() < new Date(today).getTime();
                }
            },
            //结束时间
            pickerOptionsend: {
                disabledDate(time) { //结束时间的禁用
                    var newDate = /\d{4}-\d{1,2}-\d{1,2}/g.exec(that.form.gsstarttime)
                    return time.getTime() < new Date(newDate[0] + ' 00:00').getTime() + 8.64e7 + 8.64e7;
                }
            },
            edit: false,
            regioncode: '',
            jyzxcode: '',
            deptcode: '',
            pwhCyList: [],
            tableDataSetList: [],
            offerSetList: [],
            creditScoreSetList: [],
            tableDataAllList: [],
            table: false,
            loading: false,
        }
    },
    computed: {},
    watch: {},
    methods: {
        // 获取标段信息
        bdChange() {
            this.$get(`${this.getGetters('ageUrl')}/DingBiao/ZbHxrGs/alltbdw.json`, {
                bdcode: this.form.bdcode,
                isXt: this.getQuery('isXt'),
            }, data => {
                this.form.qbtbdw = data.alltbdw
                this.form.gsname = data.gsname
                this.form.e_kbsj = data.kbsj
                this.form.ext_complaints = data.yyqd
                if (data.wxtbdw) {
                    this.dwname = data.wxtbdw
                    this.form.fjdwjly = data.fjdw
                }
                if (!this.form.bdcode) {
                    this.dwname = data.wxtbdw
                    this.form.fjdwjly = data.fjdw
                }
            });
        },
        // 获取标段
        getBdList(zbprocode) {
            var that = this
            that.$post(`${that.getGetters('ageUrl')}/revision/tree/queryZbBdList.json`, {
                zbprocode: zbprocode,
                isXt: this.getQuery('isXt'),
            }, data => {
                data.forEach(function (item) {
                    if (item.xm === 'bd') {
                        that.bdList.push(item)
                    }
                })
                // this.bdList = data
            });
        },
        // 获取公示类型name
        getgstype() {
            var that = this
            that.gstypeList.forEach(function (item) {
                if (item.value === that.form.gstypecode) {
                    that.form.gstypename = item.label
                }
            })
        },
        // 保存
        saveHandler(type, cb) {
            this.form.shbj = type;
            this.form.isXt = this.getQuery('isXt')
            cb && cb();
        },
        //自动生成公告
        neiRong: function () {
            var that = this;
            var errorMsg = "";
            // gsname, kssj, jssj, qbdw, wxdw
            if (!that.form.gsname) {
                errorMsg += "公示名称、";
            }
            if (!that.form.gsstarttime) {
                errorMsg += "公示开始时间、";
            }
            if (!that.form.gsendtime) {
                errorMsg += "公示结束时间、";
            }
            if (!that.form.qbtbdw) {
                errorMsg += "全部投标单位、";
            }
            if (!that.form.fjdwjly) {
                errorMsg += "否决单位及理由、";
            }
            if (!that.form.ext_complaints) {
                errorMsg += "异议渠道或方式、";
            }
            if (errorMsg) {
                if ("、" === errorMsg.charAt(errorMsg.length - 1)) {
                    errorMsg = errorMsg.substr(0, errorMsg.length - 1);
                }
                this.$confirm("【" + errorMsg + '】，以上数据未进行填报，生成内容时将无法生成对应数据，是否继续生成?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$post(`${this.getGetters('ageUrl')}/DingBiao/ZbHxrGs/getContent.json`, {
                        bdcode: this.form.bdcode,
                        gsname: this.form.gsname,
                        kssj: this.form.gsstarttime,
                        jssj: this.form.gsendtime,
                        qbdw: this.form.qbtbdw,
                        wxdw: this.form.fjdwjly,
                        yyqd: this.form.ext_complaints
                    }, (data, res) => {
                        if (res.code === 'v') {
                            // console.log(data)
                            that.form.gscontent = data;
                        }
                    })
                }).catch(() => {

                });
            } else {
                this.$post(`${this.getGetters('ageUrl')}/DingBiao/ZbHxrGs/getContent.json`, {
                    bdcode: this.form.bdcode,
                    gsname: this.form.gsname,
                    kssj: this.form.gsstarttime,
                    jssj: this.form.gsendtime,
                    qbdw: this.form.qbtbdw,
                    wxdw: this.form.fjdwjly,
                    yyqd: this.form.ext_complaints
                }, (data, res) => {
                    if (res.code === 'v') {
                        that.form.gscontent = data;
                    }
                })
            }
        },
        //评委分项打分
        pwfxdf: function () {
            this.table = true;
            this.loading = true;
            this.$post(`${this.getGetters('ageUrl')}/DingBiao/ZbHxrGs/queryPbDf.json`, {
                bdcode: this.form.bdcode
                // bdcode: 'I1301000075031353001001'
            }, (data, res) => {
                if (res.code === 'v') {
                    this.pwhCyList = res.tdata.pwhCyList;
                    this.tableDataAllList = res.tdata.tableDataAllList;
                    this.loading = false;
                }
            })
        },
        handleClose: function () {
            this.table = false;
        },
        copyHtmlData() {
            var Url2 = document.getElementById("copyTable").innerHTML;
            var oInput = document.createElement("input");
            oInput.value = Url2;
            document.body.appendChild(oInput);
            oInput.select(); // 选择对象
            document.execCommand("Copy"); // 执行浏览器复制命令
            oInput.className = "oInput";
            oInput.style.display = "none";
            this.$message({
                message: '成功复制到剪贴板！',
                type: 'success'
            });
        },
        copyData() {
            var el = document.getElementById("copyTable")
            var body = document.body, range, sel;

            if (document.createRange && window.getSelection) {
                range = document.createRange();
                if (window.getSelection) {
                    sel = window.getSelection();
                } else if (window.document.getSelection) {
                    sel = window.document.getSelection();
                } else if (window.document.selection) {
                    sel = window.document.selection.createRange().text;
                }
                sel.removeAllRanges();
                try {
                    range.selectNodeContents(el);
                    sel.addRange(range);
                } catch (e) {
                    range.selectNode(el);
                    sel.addRange(range);
                }
                document.execCommand("copy");
                //取消文本选中状态
                window.getSelection ? window.getSelection().removeAllRanges() : document.selection.empty();
                this.$message({
                    message: '成功复制到剪贴板！',
                    type: 'success'
                });
            }
        },
    },
    created() {
        var that = this
        var data = {}
        if (this.getQuery('id')) {
            // 编辑
            that.edit = true
            data = {procode: this.getQuery('procode'), id: this.getQuery('id'), isXt: this.getQuery('isXt'),}
        } else {
            // 添加
            data = {procode: this.getQuery('procode'), isXt: this.getQuery('isXt'),}
        }
        this.jspInit(`${this.getGetters('ageUrl')}/DingBiao/ZbHxrGs/edit.json`, data, data => {
            that.model = data
            that.getBdList(data.zbprocode)
            that.form = data.model
            that.form.fileguid = data.fileguid
            that.getgstype()
            that.jyzxcode = data.jyzxcode
            that.regioncode = data.regioncode
            that.deptcode = data.deptcode
        });
    },
    mounted() {

    }
}
</script>

<style scoped lang="scss">

</style>
